export default "__VITE_ASSET__B9GILTf0__"